import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const InfoRectIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M12 10.75a.75.75 0 01.75.75v5a.75.75 0 01-1.5 0v-5a.75.75 0 01.75-.75zM12 9a1 1 0 100-2 1 1 0 000 2z"
        fill="#001533"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.316 3.769a42.502 42.502 0 019.367 0c1.826.204 3.301 1.643 3.516 3.48.37 3.157.37 6.346 0 9.503-.215 1.837-1.69 3.275-3.516 3.48a42.5 42.5 0 01-9.367 0c-1.826-.205-3.3-1.643-3.516-3.48a40.903 40.903 0 010-9.503c.215-1.837 1.69-3.276 3.516-3.48zm9.2 1.49a41.001 41.001 0 00-9.033 0A2.486 2.486 0 005.29 7.424a39.401 39.401 0 000 9.154 2.486 2.486 0 002.193 2.164c2.977.332 6.057.332 9.033 0a2.486 2.486 0 002.193-2.164 39.401 39.401 0 000-9.154 2.486 2.486 0 00-2.193-2.163z"
        fill="#001533"
      />
    </Svg>
  );
};

export default InfoRectIcon;
